import { defineStore } from 'pinia'

export const useHelpStore = defineStore('help', {
  state: () => (
    {
      topics: undefined,
      categorized: undefined,
    }),
  getters: {
  },
  actions: {
    setTopics(topics) {
      this.topics = topics;
    },
    setCategorized(categorized) {
      this.categorized = categorized;
    },
    updateTopic(topic) {
    },
  },
});
